import axios from 'axios'


// async function quickFetch(endpoint) {
//   const response = await fetch(endpoint)
//   const json = await response.json()
//   return json.Results
// }

function get(apiBaseUrl, endpoint) {
  return axios.get(`${apiBaseUrl}${endpoint}`)
}

async function patch(apiBaseUrl, endpoint, body) {
  return axios.patch(`${apiBaseUrl}${endpoint}`, body)
}

async function post(apiBaseUrl, endpoint, body) {
  return axios.post(`${apiBaseUrl}${endpoint}`, body)
}

async function doDelete(apiBaseUrl, endpoint) {
  return axios.delete(`${apiBaseUrl}${endpoint}`)
}

export default function makeService(apiBaseUrl, endpoints) {
  return {
    async find(id) {
      return get(apiBaseUrl, `${endpoints.byId}/${id}`)
    },
    async list(payload) {
      // Get around issues with the API structure!!
      if (endpoints.readType === 'post') {
        return post(apiBaseUrl, endpoints.read, payload)
      } else {
        return get(apiBaseUrl, endpoints.read)
      }
    },
    async patch(payload) {
      return patch(apiBaseUrl, `${endpoints.patch}`, payload.body)
    },
    async post(payload) {
      return post(apiBaseUrl, `${endpoints.post}`, payload.body)
    },
    async delete(id) {
      return doDelete(apiBaseUrl, `${endpoints.delete}/${id}`)
    },
  }
}
